import {Component, Input, OnInit} from '@angular/core';
import {Log} from "ng2-logger";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {PartNumber} from "@models/partNumber.model";
import { PartNumberEquivalent } from "@models/partNumberEquivalent.model";

@Component({
    selector: 'app-part-number-equivalence-form',
    templateUrl: './part-number-equivalence-form.component.html',
    styleUrls: ['./part-number-equivalence-form.component.scss']
})
export class PartNumberEquivalenceFormComponent implements OnInit  {
    _logger = Log.create(PartNumberEquivalenceFormComponent.name);

    @Input() showValidations;
    @Input() mode: string;

    isLoading = false;

    get isFormValid() {
        return this.partNumbersForm.valid;
    }
    public partNumbersForm: UntypedFormGroup;


    public selectedPartNumber: PartNumber;
    public partNumbers: PartNumber[];


    constructor() {
    }

    ngOnInit() {
        this._logger.info("ngOnInit:: Preparing part number equivalent form");
        this.partNumbersForm = new UntypedFormGroup({
            'equivalentPartNumbers': new UntypedFormControl([])
        })
    }

    public init(partNumber: PartNumber, partNumbers: PartNumber[]) {
        this.isLoading = true;
        if (partNumber) {
            this.selectedPartNumber = partNumber;
        }
        this.partNumbers = partNumbers;

        setTimeout(() => {
            this.isLoading = false;
        }, 1000); // It is necessary because the rendering time for partNumbers is high
    }

    public getFormDetails() {
        const formData = this.partNumbersForm.getRawValue();
        return {...formData};
    }

    public resetForm() {
        this.partNumbersForm.reset();
    }

    public setForm(partNumbers: {equivalentPartNumbers: PartNumberEquivalent[]}) {
        this.partNumbersForm.setValue(partNumbers);
    }

    public isReadOnly() {
        return this.mode === 'view';
    }
}
